module.exports = __webpack_public_path__ + "resources/icon_28_down_arrow.704c1e0a69b784a9.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_down_arrow.png
// module id = 488
// module chunks = 0 1 2 3 4